import { useQuery } from '@tanstack/react-query';
import { FeatureFlag, featureFlagService } from 'commons/services';
import useStoreInfo from './useStoreInfo';

export function useFeatureFlag(featureFlag: FeatureFlag) {
  const { storeInfo } = useStoreInfo();
  const featureFlagQuery = useQuery([`${featureFlag}EnabledQuery`], () =>
    featureFlagService.isFeatureFlagEnabled(featureFlag, storeInfo.country),
  );
  return {
    enabled: featureFlagQuery.isSuccess && featureFlagQuery.data,
    loading: featureFlagQuery.isLoading,
    error: featureFlagQuery.isError,
  };
}
